import {Component, OnInit, Injector} from '@angular/core';
import {AppComponentBase} from '../../../services/AppComponentBase';
import {technicalIndicatorDisable} from '../../achart/achart.technicalIndicators';
import {ScannerPrimarySearchList, ScannerChartingStudy, ScannerSide} from '../interfaces/scanner.enums';
import {HistoryItemPeriod} from '../../../interfaces/historyItem';
import {showScannerTrialReminderModal} from '../modals/ScannerTrialReminder/show-ScannerTrialReminder-modal';
import {FullscreenScannerComponent} from '../fullscreen-scanner/fullscreen-scanner.component';
import {MobileMainView} from '../../../enums/mobile-mainViews';

@Component({
    selector: 'mobile-app-fullscreen-scanner',
    template: require('./mobile-fullscreen-scanner.component.html'),
    styles: [require('./mobile-fullscreen-scanner.component.scss')]
})
export class FullscreenScannerMobileComponent extends FullscreenScannerComponent implements OnInit {

    constructor(injector: Injector) {
        super(injector);

        this.globaGridMode.setFolderState.subscribe(v=>{
            this.savesExpanded = v;
        })

        this.globaGridMode.setScannerMobileConfigVisibility.subscribe(v=>{
            this.showConfiguration = v;
        })
    }


    public closeScannerWindow() {

        if(!this.isNarrowScanMode) {
            this.workspace.showScannerPage = false;
            this.workspace.mobileView = MobileMainView.PANEL;
            this.workspace.showMobileLandingPage = true;
        }
        else {
            this.isNarrowScanMode = false;
            this.workspace.globaGridMode.fullScreenScanerAction.next("backFromNarrow");
        }
    }

    private _savesExpanded: boolean = false;
    public get savesExpanded(): boolean {
        return this._savesExpanded;
    }

    public set savesExpanded(value: boolean) {
        this._savesExpanded = value;
    }

    public get scanInProgress()
    {

        if(this.showConfiguration && this.workspace.scanInProgress)
        {
            this.showConfiguration = false;
        }
        
        return this.workspace.scanInProgress
    }

    public get showScanResults()
    {
        return this.workspace.showScanResults
    }

    private _showConfiguration: boolean = false;
    public get showConfiguration(): boolean {
        return this._showConfiguration;
    }
    public set showConfiguration(value: boolean) {
        this._showConfiguration = value;
    }

}
